module.exports = __webpack_public_path__ + "img/featureicon4.795607fa.svg";